import { IconButton } from "@material-ui/core";
import { MoonIcon, SunIcon } from "src/components/Icon";
import { THEME_MODE } from "src/config/constants";
import { useConfigContext } from "src/context/config/configContext";

export default function ToggleThemeButton() {
  const { themeMode, toggleThemeMode } = useConfigContext();

  return (
    <IconButton size="small" onClick={() => toggleThemeMode()}>
      {themeMode === THEME_MODE.DARK ? <SunIcon /> : <MoonIcon />}
    </IconButton>
  );
}
